import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';
import { themes, ThemeName } from '../theme.ts';
import { applyTheme } from '../themeUtil.ts';

interface ThemeContextType {
  themeName: ThemeName;
  setThemeName: (name: ThemeName) => void;
}

const ThemeContext = createContext<ThemeContextType | undefined>(undefined);

export const ThemeProvider = ({ children }: { children: ReactNode }) => {
  const savedTheme = localStorage.getItem('themeName') as ThemeName | null;
  const [themeName, setThemeName] = useState<ThemeName>(savedTheme && themes[savedTheme] ? savedTheme : 'light');

  useEffect(() => {
    applyTheme(themeName);
  }, [themeName]);

  const handleSetThemeName = (name: ThemeName) => {
    setThemeName(name);
    localStorage.setItem('themeName', name);
  };

  return (
    <ThemeContext.Provider value={{ themeName, setThemeName: handleSetThemeName }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = (): ThemeContextType => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};
